import { Column, Index } from 'typeorm';
import type { TargetCustomerProfileValue } from '../../config/instance-settings-registry';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16874 — a user's personal search profile for the Sales Helper's
 * prospect search. When a user has one, their searches use it instead of the
 * company's target customer profile (`prospecting.target_profile`), without
 * changing the company's. One row per user; clearing the personal profile
 * soft-removes the row and setting it again recovers the same row, so the
 * audit trail stays on one record.
 *
 * New table, SM2 only: SM1 never names it.
 */
@Index('uq_prospecting_search_profile_user', ['fkUserId'], { unique: true })
@Entity('prospecting_search_profile')
export class ProspectingSearchProfileEntity extends BaseEntity {
	/** The tenant (instance) user whose profile this is: user._id. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('json', { name: 'profile', nullable: true })
	public profile!: TargetCustomerProfileValue | null;
}
